<template lang="pug">
#cliam_settlement_intro
  normal-cliam-settlement-info(
    v-if="productCategorySelectStyle == '1'",
    :productDetail="productDetail"
  )
  business-cliam-settlement-info(
    v-if="productCategorySelectStyle == '2'",
    :productDetail="productDetail"
  )
</template>

<script>
import NormalCliamSettlementInfo from "@/components/product/NormalCliamSettlementInfo";
import BusinessCliamSettlementInfo from "@/components/product/BusinessCliamSettlementInfo";

export default {
  name: "ProductCliamSettlementIntro",
  components: {
    "business-cliam-settlement-info": BusinessCliamSettlementInfo,
    "normal-cliam-settlement-info": NormalCliamSettlementInfo,
  },
  props: {
    productDetail: Object,
    productCategorySelectStyle: String,
  },
  data() {
    return {};
  },
};
</script>
